import React, { useEffect, useState } from "react";
import CardWrapper from "../../components/molecules/CardWrapper";
import FilterButton from "../../components/atoms/formFields/buttons/filterButton";
import VendorStore from "../../components/atoms/vendorStores";
import CardHeader from "../../components/atoms/cardHeader";
import InventoryFilter from "./components/InventoryFilter";
import { useDispatch, useSelector } from "react-redux";
import { inventoryListThunk } from "../../store/thunks/InventoryThunk";
import InventoryTabs from "./InventoryTabs";
import { useLocation } from "react-router-dom";
import { Pagination } from "../../components/atoms/pagination";

const Inventory = () => {
  const { storeId } = useSelector((state) => state?.storeData || {});
  const dispatch = useDispatch();
  const location = useLocation();
  const { list, count, loading, pageInfo } = useSelector(
    (state) => state?.inventoryList || {},
  );

  console.log("list", list);

  const { PagiNation, Filters } = location?.state || {};

  const [pagination, setPagination] = useState({
    paginationFilter: {
      offset: PagiNation ? PagiNation : 0,
      limit: 10,
      order: "DESC",
    },
    productName: Filters?.productName ? Filters?.productName : "",
    sku: Filters?.sku ? Filters?.sku : "",
    productType: Filters?.productType ? Filters?.productType : "",
    stockStatus: Filters?.stockStatus ? Filters?.stockStatus : null,
    brandId: Filters?.brandId ? Filters?.brandId : "",
    publishedDate: Filters?.publishedDate ? Filters?.publishedDate : "",
  });

  useEffect(() => {
    if (storeId) {
      setPagination((prev) => ({
        ...prev,
        inventoryId: storeId,
        paginationFilter: {
          ...prev.paginationFilter,
          offset: PagiNation ? PagiNation : prev.paginationFilter.offset,
        },
      }));
    }
  }, [storeId]);

  useEffect(() => {
    if (pagination?.inventoryId) {
      dispatch(
        inventoryListThunk({
          inventoryListingFilters: pagination,
        }),
      );
    }
  }, [dispatch, pagination]);

  return (
    <>
      <div className="content d-flex flex-column flex-column-fluid">
        <div className="container">
          <div className="d-flex flex-sm-nowrap flex-wrap justify-content-around justify-content-lg-between pb-6">
            <VendorStore />
            <FilterButton target="filter" noMargin />
          </div>
        </div>

        <InventoryFilter
          pagination={pagination}
          setPagination={setPagination}
        />
        <CardWrapper>
          <CardHeader name="Inventory List" tooltipText={"View and Manage your product inventory, stock, and pricing details."} />
          <div className="card-body p-4">
            <InventoryTabs
              list={list}
              count={count}
              storeName={storeId}
              pagination={pagination}
              setPagination={setPagination}
              pageInfo={pageInfo}
              loading={loading}
            />

            <Pagination
              pageInfo={pageInfo}
              offset={pagination?.paginationFilter?.offset}
              setOffset={(newOffset) =>
                setPagination((prev) => ({
                  ...prev,
                  paginationFilter: {
                    ...prev.paginationFilter,
                    offset: newOffset,
                  },
                }))
              }
            />
          </div>
        </CardWrapper>
      </div>
    </>
  );
};

export default Inventory;
